<!--
  --
  -- 本人確認 確認コード 入力フォーム
  --
  -->
<template>
  <c-form card-style
    v-model="valid"
    :errors="errors"
    @submit="onSubmit"
  >
    <!-- Contents -->
    <v-card-text>
      <slot/>

      <v-text-field
        label="確認コード"
        prepend-icon="fiber_pin"
        type="text"
        v-model="inputCode"
        :rules="[rule.required('確認コード'), rule.verifyCode]"
      />
    </v-card-text>

    <c-card-errors :errors="errors"/>

    <!-- Actions -->
    <v-card-actions>
      <v-spacer/>

      <v-btn
        color="primary" type="submit"
        :loading="running"
        :disabled="!valid || running"
      >
        <slot name="submit-text"/>
      </v-btn>
    </v-card-actions>
  </c-form>
</template>

<script>
import CForm from './CForm'
import CCardErrors from './CCardErrors'

import * as time from '@/libs/time'

export default {
  name: 'CVerifyCard',
  components: {
    CForm,
    CCardErrors
  },
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    // 入力コード
    inputCode: '',

    // フォームのバリデーション状態
    valid: true,

    // フォームのエラーメッセージ
    errors: [],

    // 処理中
    running: false
  }),
  methods: {
    async onSubmit () {
      // エラー表示を消す
      this.errors = []

      // コードチェックを行う
      this.running = true
      await time.wait(300)
      this.running = false
      if (this.form.code !== this.inputCode) {
        this.errors = [
          '確認コードが一致しませんでした。'
        ]
        return
      }
      if (this.form.expire && this.form.expire < Date.now()) {
        this.errors = [
          'この確認コードは有効期限を超えたため無効です。',
          '再度、確認コードを送信してください。'
        ]
        return
      }

      // コードが確認されたことを通知する
      this.running = true
      this.$emit('verified', errors => {
        this.running = false
        if (errors) {
          this.errors = errors
        }
      })
    }
  }
}
</script>
